import { render, staticRenderFns } from "./ct-cm-customer.vue?vue&type=template&id=6b6eb61c&scoped=true"
import script from "./ct-cm-customer.vue?vue&type=script&lang=js"
export * from "./ct-cm-customer.vue?vue&type=script&lang=js"
import style0 from "./ct-cm-customer.vue?vue&type=style&index=0&id=6b6eb61c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6eb61c",
  null
  
)

export default component.exports